const Config = {
  // API_BASE_URL: 'http://84.247.181.60:2000/api',
  API_BASE_URL: 'https://api.tripsecuregh.com/api',
  APP_NAME: 'TripSecure Admin',
  APP_VERSION: '1.0.0',
  
  // Auth related configs
  TOKEN_KEY: 'admin_token',
  USER_KEY: 'admin_user',
  
  // Password requirements
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/,
  
  // Email validation
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  
  // OTP config
  OTP_LENGTH: 6,
  OTP_EXPIRY_MINUTES: 10,
};

export default Config;
